import { render, staticRenderFns } from "./BaseFAQ.vue?vue&type=template&id=a7da5c4c&scoped=true&"
import script from "./BaseFAQ.vue?vue&type=script&lang=js&"
export * from "./BaseFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7da5c4c",
  null
  
)

export default component.exports